module.exports = __webpack_public_path__ + "static/media/team7.74ada027.png";